import { Icon, IconsEnum } from 'components/Icons';

import { ReactPortal } from 'components/reactPortal';
import dynamic from 'next/dynamic';
import { handleInfoTipoScommessaModal } from 'features/ippica/ippicaSlice';
import styles from './IppicaInfoScomemessaModal.module.scss';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from 'lib/centralStore';
export const DynamicIppicaModalInfoScommessa = dynamic(() =>
  import('features/ippica/components/ippicaInfoScommessaModal/IppicaInfoScommessaModal').then(
    (mod) => mod.IppicaInfoScommessaModal
  )
);

export const IppicaInfoScommessaModal = () => {
  const dispatch = useDispatch();
  const { ippicaInfoTipoScommessa } = useTypedSelector((state) => state.ippica);
  const closeModal = () => {
    dispatch(handleInfoTipoScommessaModal({ isOpen: false, title: '', description: '' }));
  };
  return (
    <ReactPortal wrapperId="ippicaInfoScommessaModal">
      <div className={styles.overlay}>
        <dialog className={`${styles.modal} ${styles.modalWrapper}`}>
          <div className={`${styles.container} ${styles.modalHeader}`}>
            {ippicaInfoTipoScommessa.title && <span className={styles.label}>{ippicaInfoTipoScommessa.title}</span>}
            <button type="button" className={styles.button} onClick={() => closeModal()}>
              <Icon iconId={IconsEnum.CLOSE} className={styles.icon} color="var(--color-on-bg-primary)" />
            </button>
          </div>
          <div className={styles.contentWrapper}>
            <p
              className={styles.description}
              suppressHydrationWarning
              dangerouslySetInnerHTML={{ __html: ippicaInfoTipoScommessa.description ?? '' }}
            />
          </div>
        </dialog>
      </div>
    </ReactPortal>
  );
};
